/**
 * Token Cache 初始化参数
 */
import {TokenType} from "../base/options";

export interface TokenCacheInitOptions {
  expiresTime?: number;  // 过期时间
}

/**
 * Cache 的策略，所有的缓存都会实现该类定义的方法
 */
export abstract class TokenCache {
  expiresTime: number;  // 过期时间

  constructor(options: TokenCacheInitOptions) {
    this.expiresTime = options.expiresTime || 7200;   // 默认7200秒过期,同步微信平台
  }

  /*
  * 更新
  * */
  abstract updateToken(type: TokenType, data: string): void;

  /*
  * 获取最新的token数据
  * */
  abstract getToken(type: TokenType): Promise<string>;
}


